import { LuStar } from 'react-icons/lu';

import { cn } from '~/utils/cnTailwind';

export const ActiveStar: React.FC<{ className: string }> = ({ className }) => (
    <LuStar aria-hidden className={cn('size-3.5 shrink-0', className)} fill="currentColor" />
);
